<template>
    <div>
    <button v-if="update" class="py-2 px-5 border rounded bg-white border-gray-400 text-xs text-black text-opacity-70 uppercase"
    :class="isValidNumber ? '' :  'cursor-not-allowed'"
        @click="isValidNumber ? modalPassword = true : null"
    >
            <em class="fas fa-key"></em>
            Redefinir senha
    </button>

    <button-confirmation
        v-else
        class="ml-2"
        :class="{ 'opacity-25': !isValidNumber }"
        :disabled="!isValidNumber"
        @click.native="showModalPassword"
    >
        Confirmar
    </button-confirmation>

    <jet-confirmation-modal
        v-if="modalPassword"
        :show="modalPassword"
        @close="modalPassword = false"
        :scroll="false"
        :noBgFooter="true"
        :maxWidth="'2xl'"
        :widthContent="'w-full'"
    >
        <template #title>
            <span class="text-black text-opacity-70 font-bold text-xl">
                {{ update ? 'Redefinir senha do cartão' : 'Criando senha do cartão' }}
            </span>
            <hr class="bg-gray-400 w-full">
        </template>

        <template #content>
            <div class="text-base text-black text-opacity-60" v-if="!update">
                Agora que seu cartão chegou certinho, vamos realizar a configuração da senha de 4 dígitos
                que será utilizada para confirmar os pagamentos realizados com ele, lembrando que esta senha deve ser
                guardada em segurança para evitar o seu esquecimento.
            </div>
            <div class="mb-3 text-base text-black text-opacity-60" v-else>
                Preencha os campos para redefinir a senha do cartão.
            </div>
            <div class="flex flex-col space-y-4">
                <div v-if="update">
                    <jet-label for="amount" value="Senha Antiga" class="text-sm"/>
                    <jet-input
                        id="amount" class="w-full"
                        type="password" v-model="form.old_password"
                        :placeholder="'Digite a senha antiga'"
                        :maxlength="4"
                    />
                    <jet-input-error :message="form.error('password')" />
                </div>
                <div>
                    <jet-label for="amount" value="Senha" class="text-sm"/>
                    <jet-input
                        id="amount" class="w-full"
                        type="password" v-model="form.password"
                        :placeholder="(update ? 'Digite uma nova senha' : 'Digite uma senha')"
                        :maxlength="4"
                        @input.native="validatePassword"
                    />
                    <jet-input-error :message="form.error('password')" />
                </div>
                <div>
                    <jet-label for="amount" value="Confirmar senha" class="text-sm"/>
                    <jet-input
                        id="amount" class="w-full"
                        type="password" v-model="form.password_confirmation"
                        :placeholder="'Confirme a senha já digitada'"
                        :maxlength="4"
                        @input.native="validatePassword"
                    />
                    <jet-input-error :message="form.error('password_confirmation')" />
                </div>
            </div>
                <div class="flex flex-col space-y-3 mt-5">
                    <div
                        class="rounded-full py-2 px-4 text-sm bg-gray-200 text-gray-500"
                        :class="(passwordErrors.four_digits === -1) ? 'bg-red-100 text-red-500'
                        : (passwordErrors.four_digits === 1) ? 'bg-green-100 text-green-600' : ''"
                    >
                        <em
                            class="fas fa-ban"
                            :class="(passwordErrors.four_digits === -1) ? 'fas fa-times'
                            : (passwordErrors.four_digits === 1) ? 'fas fa-check' : ''"
                        ></em> Deve conter 4 dígitos.
                    </div>
                    <div
                        class="rounded-full py-2 px-4 text-sm bg-gray-200 text-gray-500"
                        :class="(passwordErrors.two_repetitions === -1) ? 'bg-red-100 text-red-500'
                        : (passwordErrors.two_repetitions === 1) ? 'bg-green-100 text-green-600' : ''"
                    >
                        <em
                            class="fas fa-ban"
                            :class="(passwordErrors.two_repetitions === -1) ? 'fas fa-times'
                            : (passwordErrors.two_repetitions === 1) ? 'fas fa-check' : ''"
                        ></em> Não deve conter mais de 3 números repetidos.
                    </div>
                    <div
                        class="rounded-full py-2 px-4 text-sm bg-gray-200 text-gray-500"
                        :class="(passwordErrors.only_numbers === -1) ? 'bg-red-100 text-red-500'
                        : (passwordErrors.only_numbers === 1) ? 'bg-green-100 text-green-600' : ''"
                    >
                        <em
                            class="fas fa-ban"
                            :class="(passwordErrors.only_numbers === -1) ? 'fas fa-times'
                            : (passwordErrors.only_numbers === 1) ? 'fas fa-check' : ''"
                        ></em> Deve conter apenas números.
                    </div>
                    <div
                        class="rounded-full py-2 px-4 text-sm bg-gray-200 text-gray-500"
                        :class="(passwordErrors.avoid_birthdate === -1) ? 'bg-red-100 text-red-500'
                        : (passwordErrors.avoid_birthdate === 1) ? 'bg-green-100 text-green-600' : ''"
                    >
                        <em
                            class="fas fa-ban"
                            :class="(passwordErrors.avoid_birthdate === -1) ? 'fas fa-times'
                            : (passwordErrors.avoid_birthdate === 1) ? 'fas fa-check' : ''"
                        ></em> Evitar o uso de data de nascimento.
                    </div>
                    <div
                        class="rounded-full py-2 px-4 text-sm bg-gray-200 text-gray-500"
                        :class="(passwordErrors.password_confirmation === -1) ? 'bg-red-100 text-red-500'
                        : (passwordErrors.password_confirmation === 1) ? 'bg-green-100 text-green-600' : ''"
                    >
                        <em
                            class="fas fa-ban"
                            :class="(passwordErrors.password_confirmation === -1) ? 'fas fa-times'
                            : (passwordErrors.password_confirmation === 1) ? 'fas fa-check' : ''"
                        ></em> Campo Senha e Confirmar senha devem ser iguais.
                    </div>
                </div>
            </template>

        <template #footer>
        <div class="flex justify-between mt-4">
            <button-cancel @click.native="closeModalPassword">
                Cancelar
            </button-cancel>
            <button-confirmation @click.native="showUpdatePassword">
                Confirmar
            </button-confirmation>
        </div>
        </template>

    </jet-confirmation-modal>

       <jet-confirmation-modal
             :show="modalauthorizedUpdate"
             @close="modalauthorizedUpdate=false"
             :scroll="false"
             :max-width="'xl'"
             :noBgFooter="true"
        >
            <template #title>
                <div class="text-black text-opacity-70 font-bold text-xl py-2">
                    Confirme a solicitação com o código 2FA
                </div>
                <hr class="my-2" />
            </template>

            <template #content>
                <div class="flex flex-col space-y-4">
                    <div class="text-base text-black text-opacity-60 mt-4">
                        Autorize a solicitação através do seu código 2FA.
                    </div>
                    <div>
                        <jet-label for="amount" value="Código de autorização" class="text-xs"/>
                        <jet-input
                            id="amount" class="mt-1 w-full block"
                            type="text" v-model="form.google_code"
                        />
                        <jet-input-error :message="form.error('google_code')" />

                    </div>
                </div>
            </template>

            <template #footer>
            <div class="flex items-center justify-between">
              <button-cancel @click.native="closeModalAuthorized">
                    Cancelar
                </button-cancel>

                <button-confirmation
                    class="ml-2"
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                    @click.native="submit"
                >
                    Confirmar
                </button-confirmation>
            </div>
            </template>
        </jet-confirmation-modal>
    </div>
</template>

<script>
import JetConfirmationModal from "../../../Jetstream/ConfirmationModal";
import JetSectionBorder from "../../../Jetstream/SectionBorder";
import Button from "../../../Jetstream/Button";
import JetLabel from "../../../Jetstream/Label";
import JetInput from "../../../Jetstream/Input";
import JetInputError from "../../../Jetstream/InputError";
import ButtonConfirmation from '../../../Jetstream/ButtonConfirmation.vue';
import ButtonCancel from '../../../Jetstream/ButtonCancel.vue';

const defaultErrorsPassword = {
    four_digits: 0,
    two_repetitions: 0,
    only_numbers: 0,
    avoid_birthdate: 0,
    password_confirmation: 0,
};

export default {
    components: {
        JetConfirmationModal,
        JetSectionBorder,
        Button,
        JetLabel,
        JetInput,
        JetInputError,
        ButtonConfirmation,
        ButtonCancel
    },
    props: {
        update: {
            type: Boolean
        },
        customer: {
            type: Object,
            default: () => ({})
        },

        card: {
            type: Object,
            default: () => ({})
        },
        isValidNumber: {
            type: Boolean,
            default: false
        },
    },
     data() {
        return {
            modalPassword: false,
            modalauthorizedUpdate: false,
            form: this.$inertia.form({
                _method: 'POST',
                card_uuid: this.card?.uuid,
                card_status: this.card?.status,
                old_password: null,
                password: null,
                password_confirmation: null,
                google_code: null
            }, {
                resetOnSuccess: false,
            }),
            passwordErrors: {
               ...defaultErrorsPassword
            }
        }
    },
     methods: {
        closeModalPassword() {
            this.modalPassword = false;
            this.form.reset();
            this.passwordErrors = {...defaultErrorsPassword}

        },
        closeModalAuthorized() {
            this.modalauthorizedUpdate = false
            this.form.reset()
            this.passwordErrors = {...defaultErrorsPassword}
        },
        showModalPassword() {
            this.modalPassword = true
            this.form.reset()
        },
        validatePassword() {
            this.passwordErrors.four_digits = this.form.password.length === 4 ? 1 : -1;
            this.passwordErrors.two_repetitions = this.form.password.match(/(.)\1{1,}/g) ? -1 : 1;
            this.passwordErrors.only_numbers = this.form.password.match(/^[0-9]+$/) ? 1 : -1;

            const birth_date = this.customer.birth_date.split('T')[0].split('-').reverse().join('').replace(/\D/g, '');
            this.passwordErrors.avoid_birthdate = birth_date.includes(this.form.password) ? -1 : 1;

            this.passwordErrors.password_confirmation = this.form.password === this.form.password_confirmation ? 1 : -1;
        },
        maxSize(type) {
            if (this.form[type].length > 4) {
                this.form[type] = this.form[type].slice(0, 4)
            }
        },
        showUpdatePassword() {
            if (Object.values(this.passwordErrors).includes(-1) || Object.values(this.passwordErrors).includes(0) ) {
                this.$toast.open({
                message: 'Senha inválida, preencha os campos corretamente.',
                type: 'warning',
                duration: 5000,
                position: 'top-right',
                showCloseButtonOnHover: true
                });
                this.passwordErrors = {...defaultErrorsPassword}
                return;
            }

            if(this.update) {

                if (!this.form.old_password ) {
                this.$toast.open({
                message: 'Por favor, forneça a senha antiga para continuar.',
                type: 'warning',
                duration: 5000,
                position: 'top-right',
                showCloseButtonOnHover: true
                });
                return;
            }
             this.modalPassword = false;
             this.modalauthorizedUpdate = true;
                return;
            }

            this.submit();
        },
        submit() {
            if(this.form.processing) return;
            if (this.update) {
                this.form.post(this.route('card.submit-password-update'), {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.form.processing = false
                        this.modalPassword = false;
                        this.modalauthorizedUpdate = false
                        this.form.reset();
                    },
                    onError: () => {
                        this.form.processing = false
                        this.form.reset();
                    }
                });
            } else {
                this.form.card_uuid = this.card.uuid
                this.form.card_status = this.card.status
                this.form.post(this.route('card.submit-password-creation'), {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.modalPassword = false;
                        this.form.reset();
                        this.$emit('close-modal-cvc')
                    },
                    onError: () => {
                        this.form.processing = false
                        this.form.reset();
                    }
                });
            }
        },
    }
};
</script>
